import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Start() {
  const navigate = useNavigate();

  useEffect(() => {
    const lastPath = localStorage.getItem("furusato_last_path");
    if (lastPath) {
      // Redirect về path đã lưu
      navigate(lastPath, { replace: true });
    } else {
      // Nếu chưa có thì fallback về trang mặc định
      navigate("/furusato-nozei/top", { replace: true });
    }
  }, [navigate]);

  return null; // Không hiển thị gì
}
